import { useSelector as officialUseSelector } from "react-redux";
import { RootState } from "../reducers";

function useSelector<S>(selector: (state: RootState) => S): S {
    return officialUseSelector((state: RootState) => selector(state));
}

export default useSelector;
